export default {
  allVehicleUsageInfos: [],
  vehicleUsageInfo: {},
}
